import { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import BoxWraper from "../../../account/box-wrapper";
import Loader from "../../../shared/loader";
import auth from "../../../shared/auth";
import {  
  fetchFeatureRequest,
  addFeatureRequest,
  clearRedirect,
  fetchFeatureRequestStatuses,  
  fetchFeatureRequestPriorities
  } from "../ducks/actions";
import Form from "../edit/form";

const FeatureRequestContainer = (props) => {
 const {   
        addFeatureRequest,
        featureRequestLoading,
        errors,
        loading,
        pageSections,
        redirect,
        clearRedirect,
        fetchFeatureRequestStatuses,
        fetchFeatureRequestPriorities,
        emptyFeatureRequest,
        statuses,
        priorities,
        prioritiesLoading } = props;

useEffect(() => {
  if (auth.isAdmin()) {
    fetchFeatureRequestStatuses();
  }

  fetchFeatureRequestPriorities();
 }, []);

 if (redirect) {
  if (redirect.to === "list") {
    clearRedirect();    
    const url = `/feature-request`;
    return <Redirect to={url} />;
  }
}

const handleFeedbackFormSubmit = (featureRequest) => {        
  addFeatureRequest(featureRequest, true);
};

 return (    
    <BoxWraper width={5}>
        {(featureRequestLoading || loading || prioritiesLoading) && <Loader/>}
        {(!featureRequestLoading || loading || prioritiesLoading) && <Form           
          initialValues={emptyFeatureRequest}
          pageSections={pageSections}
          statuses={statuses}
          priorities={priorities}
          errors={errors}
          isAdmin={auth.isAdmin()}
          onSubmit={handleFeedbackFormSubmit} />}
    </BoxWraper>
  );
}

function mapStateToChangeLogs(state) {
    const { featureRequestState, commonState } = state;
    return {
      loading: featureRequestState.loading,
      featureRequestLoading: featureRequestState.featureRequestLoading,
      errors: featureRequestState.featureRequestErrors,
      redirect: featureRequestState.redirect,
      statuses: featureRequestState.statuses,
      priorities: featureRequestState.priorities,
      prioritiesLoading: featureRequestState.prioritiesLoading,
      emptyFeatureRequest : featureRequestState.emptyFeatureRequest,
      pageSections: commonState.pageSections
    };
  }
  
  export default connect(mapStateToChangeLogs, {
    fetchFeatureRequest,
    addFeatureRequest,
    clearRedirect,
    fetchFeatureRequestStatuses,
    fetchFeatureRequestPriorities
  })(FeatureRequestContainer);
  